import { rideMembers } from './Passengers';

export const SUPPORTED_GENRES = ['rap', 'hip hop', 'pop', 'r&b', 'rock', 'edm', 'indie', 'classical', 'country'];

export function normalizeGenres(values, supported = SUPPORTED_GENRES) {
  const choices = new Set((Array.isArray(values) ? values : [])
    .filter(value => typeof value === 'string').map(value => value.trim().toLowerCase()));
  return supported.filter(genre => choices.has(genre));
}

export function genreDistribution({ genres = SUPPORTED_GENRES, selected = [], live = {}, self, now = Date.now() }) {
  const rows = normalizeGenres(genres).map(genre => ({ genre, count: 0, percent: 0 }));
  const add = preferences => {
    const choices = normalizeGenres(preferences);
    rows.forEach(row => { if (choices.includes(row.genre)) row.count += 1; });
  };
  // The local selection replaces this listener's possibly stale snapshot.
  add(selected);
  rideMembers(live || {}, self, now).forEach(({ id }) => {
    if (id !== self) add(live[id]?.pax_preferences);
  });
  const total = rows.reduce((sum, row) => sum + row.count, 0);
  if (total) {
    rows.forEach(row => { row.percent = Math.floor(row.count * 100 / total); });
    // Largest remainders keep whole percentages at 100, with stable genre-order ties.
    const remainderOrder = rows.map((row, index) => ({ row, index, remainder: row.count * 100 % total }))
      .sort((a, b) => b.remainder - a.remainder || a.index - b.index);
    const remaining = 100 - rows.reduce((sum, row) => sum + row.percent, 0);
    remainderOrder.slice(0, remaining).forEach(({ row }) => { row.percent += 1; });
  }
  return { rows: rows.sort((a, b) => b.count - a.count), total };
}
